const state = {
  rightTreeData: {},
  services: {},
  nodeTreeArray: [], // 接收webscoket树形数据
  policeArray: [], // 接收报警webscoket数据
  eventArray: [], // 接收事件webscoket数据
  userArray: [], // 接收登录在线用户
  tellhow: true,
  tellhowShow: false,
  nodeTree: {},
  objectInfo: {}, // 用来接收列表双击事件对象
  toolTreeNode: {}, // 用来接收设计工具树节点对象
  dialogShow: false,
  propertiesDialogShow: false,
  onlineChartDialogShow: false,
  onlineChartTrendShow: false,
  // 图形化展示
  graphiCallyShow: false,
  noteBookShow: false, // 记事本
  dataInterfaceShow: false, // 数据接口
  topicShow: false, // 记事本
  doorShow: false, // 门禁
  trendLogsShow: false, // 趋势日志展示
  usersShow: false, // 人员管理
  countBookShow: false, // 计算工具
  trendJournalShow: false, // 趋势日志
  trendJournalExpressShow: false, // 趋势日志导出
  createUserShow: false,
  userShow: false,
  userListShow: false,
  listDialogShow: false,
  createGroupShow: false,
  groupShow: false,
  authorityShow: false,
  selectDialogShow: false,
  selectTypeDialogShow: false,
  alarmChartDialogShow: false,
  changeOfStateShow: false,
  alarmControlShow: false,
  groupAlarmShow: false,
  deviceDialogShow: false,
  // 程序下载
  orderDialogShow: false,
  deviceListDialogShow: false,
  isReloadTree: false,
  pointShow: false,
  addFolderDialog: false,
  addFolderDesginDialog: false,
  type: '',
  timeChartShow: false, // 时间计划表
  timeChartBatchShow: false, // 时间计划表
  timeChartValueShow: false, // 时间计划表
  timeChartBathShow: false, // 时间计划表批量
  energyDialogShow: false, // 能耗资源
  energyStatisticsShow: false, // 能耗资源
  energyBarShow: false, // 能耗资源
  coilDialogShow: false, // 盘管检查
  holidayShow: false, // 假期计划表
  searchDialogShow: false,
  addTreeNode: null, // 用来接收新增的树节点
  updateTreeNode: null, // 用来接收修改的树节点
  delTreeNode: null, // 用来接收删除的树节点
  pointData: {},
  alarmNum: 0, // 用来接收报警的总数
  eventNum: 0, // 用来接收事件的总数
  usersNum: 0, // 用来接收用户的总数
  toggle: false, // 用来表示报警/事件/搜索区域是否展开
  searchResult: [], // 用来接收搜索的结果
  tabPanel: null, // 用来接收标签页对象
  searchParams: null, // 用来接收搜索条件
  loginStatus: false, // 用来接收玩家的登录状态
  leftClickNode: 0, // 用来接收左键点击树节点
  objectTransferShow: false,
  timeEventObjectShow: false,
  timeEventListShow: false,
  nodeAll: [], // 完整的树目录结构
  squareDialogShow: false, // 创建方波
  ruleDialogShow: false, // 创建规则
  statisticsModuleShow: false, // 统计模块
  labelManageShow: false, // 标签管理
  sortTree: {}, // 修改表格排序后左侧树需要刷新的部分
  EHIShow: false, // 环境健康指数
  hkvideoShow: false, // 海康摄像头
  ehiLabelManageShow: false, // EHI专用的标签管理
  valueCalculationShow: false // 值计算功能
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/state.js